module.exports = __webpack_public_path__ + "img/rank_award_banner.7b182a5f.png";